<template>
	<div class="hundred">
		<header class="sy-ch-header">
			<div class="sy-he-col col-main container-fluid">
				<h4 class="fz-16">{{storeSetting.Name}}</h4>
			</div>
		</header>

		<div class="menu-mobile main">
			<div class="me-ma-col col-main">
				<div class="auto">
					<div class="menu">
						<ul v-if = "!loggedIn">
							<li v-for = "tab in navTabs">
								<router-link v-bind:to = "{path: tab.path}" > 
									{{tab.name}}
								</router-link>
							</li>
						</ul>
						<ul v-else>
							<li v-for = "tab in loggedInTabs">
								<router-link v-bind:to = "{path: tab.path}" > 
									{{tab.name}}
								</router-link>
							</li>
							<li>
								<a @click = "logout">
									Logout
								</a>
							</li>
							
						</ul>
					</div>
				</div>
			</div>
		</div>
		<div class="menu-mobile cover"></div>

<!-- 
    <div style="display: none;">
      <a data-fancybox href="#search-result"></a>
      <div id="search-result" class="popup-content">
        <div class="po-co-main">
          <p>Sample Text Goes Here</p>
        </div>
      </div>
  </div> -->


  <!--==================== NAVIGATION ======================-->
  <section id="main-wrapper" v-if = "loaded">
  	<router-view>
  	</router-view>
  </section>
</div>
</template>
<script>
var bID;
export default {
  //=========================================================//
  //                                                         //
  //                            DATA                         //
  //                                                         //
  //=========================================================//
  data(){
    //----------------- VAR DECLARATION ---------------------//
    // NAVIGATION BAR
    var prefix = "/" +  this.$route.params.businessID;
    var navTabs = [
    {
    	path: prefix + '/login',
    	name: 'Login',
    },
    {
    	path: prefix + '/forgot-password',
    	name: 'Forgot Password',
    },
    ]
    var loggedInTabs = [
    {
    	path: prefix + '/orders',
    	name: 'Orders',
    },
    {
    	path: prefix + '/history',
    	name: 'History',
    },
    {
    	path: prefix + '/manager/schedule',
    	name: 'Manage Store',
    },
    {
    	path: prefix + '/profile-manager/update-password',
    	name: 'Manage Profile',
    }
    ]
    return{
    	navTabs: navTabs,
    	loggedInTabs: loggedInTabs,
    	cart: [],
    	depth:0,
    	loggedIn: false,
    	loggingIn: false,
    	allOrders: [],

    	storeSetting: {},
    	loaded: false
    }
},
mounted(){
},
firestore(){
	this.routeHandle();
	this.loggedIn = myFB.auth.currentUser != null;
	bID = this.$route.params.businessID;

	if (this.loggedIn){
		var currentUser = myFB.auth.currentUser;
		myFB.getDoc("business/" + bID + "/admins",currentUser.uid).get().then(res =>{
			if (!res.exists){
				myFB.getDoc("superadmins",currentUser.uid).get().then(res2 =>{
					if (!res2.exists){
						myFB.auth.signOut();
						myNotify.toast("You do not have permission to view this page.");
						this.$router.push("/" + bID + "/login");
					}
				});
			}
		}).catch(e=>{
			console.log(e.message);
		})
	}
	else{
		this.$router.push("/" + this.$route.params.businessID + "/login");
	}
	this.$binding("storeSetting",myFB.getDoc("business/" + bID + "/settings","storeSetting")).then(r=>{
		this.loaded = true;
	})
},


  //=========================================================//
  //                                                         //
  //                            WATCH                        //
  //                                                         //
  //=========================================================//
  watch:{
  	"$route.path": function(){
  		if (bID != this.$route.params.businessID){
  			bID = this.$route.params.businessID;
  			this.loaded = false;
  			this.$binding("storeSetting",myFB.getDoc("business/" + bID + "/settings","storeSetting")).then(r=>{
  				this.loaded = true;
  			})
  		}
  		this.routeHandle();
  	},
  	storeSetting(){
  		this.routeHandle();
  		customJS.runAll();
  	}
  },



  //=========================================================//
  //                                                         //
  //                            METHODS                      //
  //                                                         //
  //=========================================================//
  methods: {
  	routeHandle(){
  		document.title = this.$route.name + " | " + this.storeSetting.Name ;
      // this.loggedIn = myFB.auth.currentUser != null;

      var htmlPath = this.$route.path;
      this.loggedIn = myFB.auth.currentUser != null;
      this.loggingIn = htmlPath.includes("login") || htmlPath.includes("forgot-password");

      if (!this.loggedIn && ! this.loggingIn){
      	this.$router.push("/" + this.$route.params.businessID + "/login");
      }
  },
  logout(){
  	myFB.auth.signOut().then(r=>{
  		var prefix = "/" +  this.$route.params.businessID;
  		this.$router.push(prefix + "/login");
  	}).catch(e=>{
  		console.log(e.message);
  	})
  }
}
}
</script>



// WEBPACK FOOTER //
// src/components/Business.vue